export const PlainText = ({ contents }) => (
    <span>{contents}</span>
    // <Typography variant={'bodyRegular'}>{contents}</Typography>
)
